import { IconProps } from './Icon';

export const MoreIcon = ({ width, height, className }: IconProps) => (
  <svg
    className={className}
    height={height}
    id="Capa_1"
    version="1.1"
    viewBox="0 0 515.555 515.555"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m496.679 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" />
    <path d="m303.347 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" />
    <path d="m110.014 212.208c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" />
  </svg>
);
